import React, { Component, Fragment } from 'react'
import PropTypes from 'prop-types'
import CKEditor from 'ckeditor4-react'
import { ckeditorToolbar } from '../helpers'
import { Row } from 'react-flexbox-grid'
import { GlgButton, GlgSwitch, GlgRangeSlider, GlgColorPicker } from 'SharedComponents'
import ChangeImagePopup from './change_image_popup'
import FooterComponent from './footer_component'
import { MIN_FOOTER_HEIGHT, MAX_FOOTER_HEIGHT, FOOTER_VARS } from '../constants'

class FooterSetupComponent extends Component {

  setEditorDefaultConfiguration(editor) {
    const userSetEmptyText = this.props.text === ''
    if ( (editor.getData() || '').length > 0 || userSetEmptyText ) {
      return
    }

    const defaultStyle =
      `<p style="text-align: right">
        <span style="font-family: Arial, Helvetica, sans-serif">
        <span style="font-size: 16px;">
          %round.date%
        </span></span>
      </p>`

    editor.setData( defaultStyle )
    this.props.setText( defaultStyle )
  }

  render(){
    const {
      isVisible,
      toggleVisible,
      height,
      changeHeight,
      selectedBackground,
      backgroundImage,
      backgroundOpacity,
      changeOpacity,
      selectBackgroundType,
      text,
      setText,
      setBackgroundColor,
      setEditorInstance,
    } = this.props

    return (
      <div id='footer_setup' className='grey_border'>
        <div className='justify-center add-margin-top-15'>
          <GlgSwitch
            id='footer-popup-visible-switch'
            text={ [ (!window.I18n ? '' : window.I18n.t('tv_shows.components.footer_setup_component.visible')),
                            (!window.I18n ? '' : window.I18n.t('tv_shows.components.footer_setup_component.hidden')) ] }
            widthInPixels={ 80 }
            checked={ isVisible }
            onChange={ toggleVisible } />
        </div>
        <Row>
          <ul className='col-xs-12 col-sm-8'>
            <li className='form_row no-border-bottom'>
              <div className='col-xs-12'>
                <div className='popup-section-title'>
                  { !window.I18n ? '' : window.I18n.t('tv_shows.components.footer_setup_component.preview') }
                </div>
              </div>
              <div className='col-xs-12'>
                <div className='popup-section'>
                  <FooterComponent isPreview={true} {...this.props} />
                </div>
              </div>
            </li>
            <li className='form_row no-border-bottom'>
              <div className='popup-section-title col-xs-12'>
                { !window.I18n ? '' : window.I18n.t('buttons.edit') }
              </div>
              <div className='popup-section col-xs-12'>
                <CKEditor
                  id="footer_content_textarea"
                  data={ text }
                  onChange={ (e) => setText(e.editor.getData()) }
                  onInstanceReady={ e => {
                    setEditorInstance(e.editor)
                    this.setEditorDefaultConfiguration(e.editor)
                    window.glg.translation.ckeditorHtmlLang(e.editor)
                  } }
                  config={{
                    toolbar: ckeditorToolbar,
                    contentsCss: this.props.ckeditorStyle,
                    resize_maxHeight: 400,
                    height: 100,
                  }} />
              </div>
            </li>
            <li className='form_row no-border-bottom'>
              <div className='popup-section-title col-xs-12'>
                { !window.I18n ? '' : window.I18n.t('tv_shows.components.footer_setup_component.fields') }
              </div>
              <div className='popup-section col-xs-12'>
                <div className='input_fields input_fields_height no-padding white_background'>
                  <div className='email-template-variables col-xs-12'>
                    { FOOTER_VARS.map( ([ label, placeholder ], index) => (
                      <a
                        className='insert-in-ckeditor'
                        key={ index }
                        onClick={ () => { this.props.editorInstance.insertText(placeholder) } }
                      >
                        { !window.I18n ? '' : window.I18n.t('tv_shows.constants.' + label.replace(' ', '_').toLowerCase()) }
                      </a>
                    ))}
                  </div>
                </div>
              </div>
            </li>
          </ul>
          <ul className='col-xs-12 col-sm-4 no-padding-left'>
            <li className='form_row add-margin-top-20 add-margin-right-20'>
              <div className='popup-section-title col-xs-12'>
                { !window.I18n ? '' : window.I18n.t('tv_shows.components.footer_setup_component.footer_height') }
              </div>
              <div className='popup-section col-xs-12 vertical-align-items'>
                <GlgRangeSlider
                  value={ height }
                  min={ MIN_FOOTER_HEIGHT }
                  max={ MAX_FOOTER_HEIGHT }
                  unit={ 'px' }
                  onChange={ changeHeight } />
              </div>
            </li>
            <li className='form_row add-margin-top-20 add-margin-right-20 no-border-bottom clearfix' style={{ overflow: 'visible' }}>
              <div className='popup-section-title col-xs-12'>
                { !window.I18n ? '' : window.I18n.t('tv_shows.components.footer_setup_component.background') }
              </div>
              <div className='popup-section vertical-align-items col-xs-12 no-padding'>
                <div className='col-xs-4 add-margin-top-20 add-margin-bottom-20'>
                  <div className='radio btsp_radio radio-primary no-margin'>
                    <input
                      type="radio"
                      checked={ selectedBackground === 'none' }
                      onChange={ () => { selectBackgroundType('none') } }
                      id="none" />
                    <label htmlFor="none">
                      <span>
                        { !window.I18n ? '' : window.I18n.t('tv_shows.components.footer_setup_component.none').toLowerCase() }
                      </span>
                    </label>
                  </div>
                  <div className='radio btsp_radio radio-primary no-margin'>
                    <input
                      type="radio"
                      checked={ selectedBackground === 'color' }
                      onChange={ () => { selectBackgroundType('color') } }
                      id="color" />
                    <label htmlFor="color">
                      <span>
                        { !window.I18n ? '' : window.I18n.t('tv_shows.components.footer_setup_component.color') }
                      </span>
                    </label>
                  </div>
                  <div className='radio btsp_radio radio-primary no-margin'>
                    <input
                      type="radio"
                      checked={ selectedBackground === 'image' }
                      onChange={ () => { selectBackgroundType('image') } }
                      id="image" />
                    <label htmlFor="image">
                      <span>
                        { !window.I18n ? '' : window.I18n.t('tv_shows.components.footer_setup_component.image') }
                      </span>
                    </label>
                  </div>
                </div>
                { selectedBackground === 'color' && (
                  <div className='col-xs-8'>
                    <div className='background-container'>
                      <GlgColorPicker
                        name="background[color]"
                        color={ this.props.backgroundColor }
                        pickerPosition="top"
                        disableAlpha={ true }
                        onChange={ color => { setBackgroundColor(color.hex) } } />
                    </div>
                  </div>
                )}
                { selectedBackground === 'image' && (
                  <Fragment>
                    <div className='col-xs-4'>
                      <div className='background-container'>
                        <img src={ backgroundImage } />
                      </div>
                    </div>
                    <div className='col-xs-4'>
                      <GlgButton
                        className='float-right'
                        text={ !window.I18n ? '' : window.I18n.t('tv_shows.components.footer_setup_component.change') }
                        color="white"
                        onClick={ () => { this.props.setPopupProperty('backgroundImage', 'show', true) } } />
                    </div>
                  </Fragment>
                )}
              </div>
            </li>

            <li className='form_row add-margin-top-20 add-margin-right-20'>
              <div className='popup-section-title col-xs-12'>
                { !window.I18n ? '' : window.I18n.t('tv_shows.components.footer_setup_component.background_opacity') }
              </div>
              <div className='popup-section col-xs-12 vertical-align-items' style={{ height: '100%' }}>
                <GlgRangeSlider
                  value={ backgroundOpacity }
                  unit={ '%' }
                  onChange={ changeOpacity } />
              </div>
            </li>
          </ul>
        </Row>
        <ChangeImagePopup
          { ...this.props.popups.backgroundImage }
          fetchImagesPath={ this.props.paths.fetchBannersImagesLinks }
          uploadImagePath={ this.props.paths.uploadBanner }
          updateImageTitlePath= { this.props.paths.updateLogoOrBannerTitle }
          onClose={ () => { this.props.setPopupProperty('backgroundImage', 'show', false) } }
          setImage={ (value) => this.props.setImage(value) } />
      </div>
    )
  }
}

// ================================================================================================================

FooterSetupComponent.propTypes = {
  isVisible: PropTypes.bool.isRequired,
  show: PropTypes.bool,
  height: PropTypes.number.isRequired,
  toggleVisible: PropTypes.func.isRequired,
  changeHeight: PropTypes.func.isRequired,
  selectedBackground: PropTypes.string.isRequired,
  backgroundColor: PropTypes.string.isRequired,
  backgroundImage: PropTypes.string.isRequired,
  setImage: PropTypes.func.isRequired,
  backgroundOpacity: PropTypes.number.isRequired,
  changeOpacity: PropTypes.func.isRequired,
  selectBackgroundType: PropTypes.func.isRequired,
  text: PropTypes.string.isRequired,
  setText: PropTypes.func.isRequired,
  setBackgroundColor: PropTypes.func.isRequired,
  popups: PropTypes.object.isRequired,
  editorInstance: PropTypes.object,
  setEditorInstance: PropTypes.func.isRequired,
  setPopupProperty: PropTypes.func.isRequired,
  ckeditorStyle: PropTypes.string.isRequired,
  paths: PropTypes.object.isRequired,
}

export default FooterSetupComponent
